import * as Feather from "react-feather";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { getCountdown } from "../../helper/Countdown";
import { api, baseURL, customerReqConfig } from "../../include/api";
import { useNotification } from "../../Toast/ToastProvider";
import { CHECKOUT, ERROR, SUCCESS } from "../../include/constant";
import {
  calculateProductPrice,
  getCart,
  getCustomer,
  isEmptyObj,
  ratingAvg1,
  setToLocalStorage,
} from "../../include/function";
import { useCart } from "../context/UserCartCountContext";
import { useParams } from "react-router-dom";
import {
  handleWishlist,
  loadCartData,
  loadWishlist,
} from "../../helper/cartUtils";
import { ChevronLeft, ChevronRight } from "react-feather";
import {
  QuantityControl,
  QuantityControlQty,
} from "../../helper/QuantityControl";
import { Modal } from "react-bootstrap";
import SimilarProducts from "../SimilarProducts";
import RecentlyView from "../RecentlyView";
import ExploreMore from "../ExploreMore";

const ProductDetails = () => {
  const { productID } = useParams();
  const [loadingAction, setLoadingAction] = useState({ type: null, id: null });
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  const [product, setProduct] = useState({});
  const [fetchLoading, setFetchLoading] = useState(true);
  const [mainImage, setMainImage] = useState("");
  const [addressList, setAddressList] = useState([]);
  const { fetchCartCount, setTotalWishlistItems } = useCart();
  const navigate = useNavigate();
  const [localCart, setLocalCart] = useState(getCart());
  const [selectedStars, setSelectedStars] = useState(0);
  const [message, setMessage] = useState("");
  const [customerNames, setCustomerNames] = useState({});
  const [reviewRefreshTrigger, setReviewRefreshTrigger] = useState(false);
  const [loading, setLoading] = useState(null);
  const [wishlistProductIds, setWishlistProductIds] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const toast = useNotification();
  const [cartData, setCartData] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const customer = getCustomer();
  const [selectedImage, setSelectedImage] = useState(mainImage || null);
  const [compareList, setCompareList] = useState([]);
  const [frequentlyBoughtProducts, setFrequentlyBoughtProducts] = useState([]);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedTier, setSelectedTier] = useState(null);
  const [qtyTiers, setQtyTiers] = useState([]);
  const [quantityType, setQuantityType] = useState("kg");
  const [priceBreakup, setPriceBreakup] = useState({
    rows: [],
    netWeight: 0,
    netAmount: 0,
    discount: 0,
    totalAmount: 0,
  });

  const [appliedData, setAppliedData] = useState([]);

  const ratingCounts = useMemo(() => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    product?.ratingAndReview?.forEach((review) => {
      const rounded = Math.ceil(review.rating);
      if (counts[rounded] !== undefined) counts[rounded]++;
    });

    return counts;
  }, [product]);

  //qty setings
  // const handleIncrement = () => {
  //   setQuantity((prev) => prev + 1);
  // };
  // const handleDecrement = () => {
  //   setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  // };

  const handleIncrement = () => {
    if (!selectedTier) return;

    setQuantity((prev) => {
      const num = Number(prev) || selectedTier.minQty;
      return Math.min(num + 1, selectedTier.maxQty);
    });
  };

  const handleDecrement = () => {
    if (!selectedTier) return;

    setQuantity((prev) => {
      const num = Number(prev) || selectedTier.minQty;
      return Math.max(num - 1, selectedTier.minQty);
    });
  };

  const handleTierClick = (tier) => {
    setActiveIndex(tier.id);
    setSelectedTier(tier);
    setQuantity(tier.minQty);
  };

  // State for steel/variant products
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedSizesQuantities, setSelectedSizesQuantities] = useState({});

  const handleToggleSize = (size) => {
    setSelectedSizes((prev) =>
      prev.includes(size) ? prev.filter((s) => s !== size) : [...prev, size],
    );

    //Initialize quantity to 1 when size is selected
    if (!selectedSizes.includes(size)) {
      setSelectedSizesQuantities((prev) => ({
        ...prev,
        [size]: 1,
      }));
    } else {
      // Remove quantity when deselected
      setSelectedSizesQuantities((prev) => {
        const newQuant = { ...prev };
        delete newQuant[size];
        return newQuant;
      });
    }
  };

  const handleQuantityChangeSteel = (size, qty) => {
    setSelectedSizesQuantities((prev) => ({
      ...prev,
      [size]: qty,
    }));
  };

  const handleQuantityChange = (val) => {
    const num = Number(val);
    if (Number.isNaN(num) || num < 1) {
      // Fallback to first tier if invalid
      const firstTier = qtyTiers[0];
      setQuantity(firstTier.minQty);
      setSelectedTier(firstTier);
      setActiveIndex(firstTier.id);
      return;
    }

    let matchedTier = qtyTiers[0];
    for (const tier of qtyTiers) {
      if (num >= tier.minQty) {
        matchedTier = tier;
      } else {
        break;
      }
    }

    // Update state
    setQuantity(num);
    setSelectedTier(matchedTier);
    setActiveIndex(matchedTier.id);
  };

  // CompareList functionality
  const handleCompareList = () => {
    const exsist = compareList.some((p) => p.id === product.id);
    if (exsist) {
      setCompareList((prev) => prev.filter((p) => p.id !== product.id));
      toast({ type: "error", message: "Removed from Compare" });
      return;
    }
    if (compareList.length >= 4) {
      toast({
        type: "error",
        message: "You can only compare upto 4 products.",
      });
      return;
    }
    // if (compareList.length > 0) {
    //   const firstCategory = compareList[0].categoryName;
    //   const currentProductCategory =
    //     product?.category?.[0]?.categoryName || "Unknown";

    //   if (firstCategory !== currentProductCategory) {
    //     toast({
    //       type: "error",
    //       message: `You can only compare products from the same category. `,
    //     });
    //     return;
    //   }
    // }

    const compareProduct = {
      id: product.id,
      name: product.name,
      price: parseFloat(product.price),
      mainImage: product.mainImage,
      //  images: product.images?.map((img) => img.imageUrl) || [],
      shopName: product.shopName,
      description: product.description,
      categoryName: product.category?.[0]?.categoryName || "Unknown",
      categoryIds: product.category?.map((c) => c.id) || [],
      mrp: parseFloat(product.price),
      discountLabel: product.discountLabel || "",
      discountMode: product.discountMode,
      discountValue: parseFloat(product.discountValue) || 0,
      subTotal: Math.round(
        product.discountMode === "percent"
          ? product.price - (product.price * product.discountValue) / 100
          : product.price - product.discountValue,
      ),
      warrantyPeriod: product.warrantyPeriod,
      warrantyMode: product.warrantyMode,
      warrantyLabel: product.warrantyLabel,
      code: product.code || "N/A",
      stockAvail: product.stockAvail,
      deliveryCharge: parseFloat(product.deliveryCharge) || 0,
      rating: product.rating || 0,
      totalReviews: product.ratingAndReview?.length || 0,
    };
    setCompareList((prev) => [...prev, compareProduct]);
    toast({ type: "success", message: "Added to  Compare" });
  };

  const removeFromCompare = (productId) => {
    setCompareList((prev) => prev.filter((p) => p.id !== productId));
  };

  const clearCompareList = () => {
    setCompareList([]);
  };

  useEffect(() => {
    const saved = localStorage.getItem("compareList");
    if (saved) {
      try {
        setCompareList(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse compareList from localStorage");
      }
    }
  }, []);

  // Sync localStorage when compareList changes
  useEffect(() => {
    localStorage.setItem("compareList", JSON.stringify(compareList));
  }, [compareList]);


  useEffect(() => {
    api
      .get("/product/?id=" + productID, customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const productData = response.data.data[0];
          setProduct(productData);

          if (
            // productData?.category?.[0]?.categoryName?.toLowerCase() === "cement" &&
            productData?.qtyAndPrice?.length > 0
          ) {
            const sorted = [...productData.qtyAndPrice].sort(
              (a, b) => a.minQty - b.minQty,
            );

            setQtyTiers(sorted);

            const lowestTier = sorted[0];
            setSelectedTier(lowestTier);
            setActiveIndex(lowestTier.id);
            setQuantity(lowestTier.minQty);
          }
        }
      })
      .finally(() => setFetchLoading(false));
  }, [productID, reviewRefreshTrigger]);

  useEffect(() => {
    if (product && product.mainImage) {
      const updatedImages = [product.mainImage];

      if (product.images?.length > 0) {
        product.images.forEach((img) => {
          if (img.imageUrl) updatedImages.push(img.imageUrl);
        });
      }

      setMainImage(product.mainImage);
      setProductImages(updatedImages);
    }
  }, [product]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (customer?.id) {
      api
        .get(
          `/customer_address/?customerId=${customer.id}`,
          customerReqConfig(),
        )
        .then((response) => {
          if (response.status === 200) {
            setAddressList(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch addresses", error);
          setAddressList([]);
        });
    } else {
      setAddressList([]);
    }
  }, []);
  // Custom Arrows
  const NextArrow = ({ onClick }) => (
    <div
      className="slick-arrow slick-next"
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#cccccc",
        borderRadius: "50%",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
        width: "28px",
        height: "28px",
        cursor: "pointer",
        right: "-30px",
        zIndex: 1,
      }}
    >
      <ChevronRight size={22} color="whitesmoke" />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="slick-arrow slick-prev"
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#cccccc",
        borderRadius: "50%",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
        color: "whitesmoke",
        width: "28px",
        height: "28px",
        cursor: "pointer",
        left: "-30px",
        zIndex: 1,
      }}
    >
      <ChevronLeft size={22} color="whitesmoke" />
    </div>
  );

  const settingsThumbs = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    centerMode: false,
    variableWidth: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const fetchcart = () => {
    if (customer) {
      api
        .get("/cart/?customerId=" + customer.id, customerReqConfig())
        .then((response) => {
          if (response.status === 200) {
            setCartData(response.data.data);
          }
        })
        .catch((error) => {
          setCartData([]);
        })
        .finally();
    } else {
      setCartData([]);
    }
  };

  useEffect(() => {
    fetchcart();
  }, []);

  useEffect(() => {
    if (customer?.id) {
      loadWishlist(
        customer.id,
        setWishlistProductIds,
        setTotalWishlistItems,
        setFetchLoading,
      );
    }
  }, [customer?.id, setTotalWishlistItems]);

  useEffect(() => {
    const handleWishlistUpdate = () => {
      if (customer?.id) {
        // Re-fetch wishlist and update state
        loadWishlist(
          customer.id,
          setWishlistProductIds,
          setTotalWishlistItems,
          () => {},
        );
      }
    };

    window.addEventListener("wishlistUpdated", handleWishlistUpdate);
    return () =>
      window.removeEventListener("wishlistUpdated", handleWishlistUpdate);
  }, [customer?.id, setWishlistProductIds, setTotalWishlistItems]);
  // Wishlist Handler
  const wishListHandler = async (item) => {
    // Prevent double-clicks for the same product
    if (loading === item.id) return; // Already processing this item

    setLoading(item.id);
    await handleWishlist({
      item,
      customer,
      wishlistProductIds,
      setWishlistProductIds,
      setTotalWishlistItems,
      toast,
    });
    setLoading(null);
  };

  const isInCart = () =>
    !isEmptyObj(customer)
      ? cartData && cartData[0]
        ? cartData[0].cartItems?.filter(
            (c) => String(c.productId) === String(product.id),
          ).length > 0
        : false
      : localCart.filter((c) => String(c.id) === String(product.id)).length > 0;

  const handleCheckout = async () => {
    if (loading === "checkout") return;
    setLoading("checkout");
    try {
      const response = await api.get(
        "/cart/?customerId=" + customer.id,
        customerReqConfig(),
      );
      if (
        response.status !== 200 ||
        !response.data.data ||
        response.data.data.length === 0
      ) {
        toast({
          type: ERROR,
          message: "Your cart is empty or could not be loaded.",
        });
        setLoading(null);
        return;
      }
      const freshCart = response.data.data;
      const currentCart = freshCart[0];
      if (
        !currentCart.cartItems ||
        !Array.isArray(currentCart.cartItems) ||
        currentCart.cartItems.length === 0
      ) {
        toast({
          type: ERROR,
          message: "No items in cart.",
        });
        setLoading(null);
        return;
      }
      // Check for inactive products
      const inactiveProducts = currentCart.cartItems.filter(
        (f) => f.status === "inactive" || f.shopStatus === "inactive",
      );
      if (inactiveProducts.length > 0) {
        toast({
          type: ERROR,
          message: "Please remove unavailable products from your cart",
        });
        setLoading(null);
        return;
      }
      // Build order data
      const orderItems = currentCart.cartItems.map((item) => ({
        ...item,
        total: item.qty * item.price,
      }));
      console.log("orderItems",orderItems);
      
      const checkoutData = {
        totalItems: currentCart.cartItems.length,
        billAmount: currentCart.itemsPrice,
        totalDiscount: currentCart.totalDiscountValue,
        totalDeliveryCharge: currentCart.totalDeliveryCharge,
        totalAmount: currentCart.totalPrice,
        isBuyNow:true,
        orderItems,
      };
      await setToLocalStorage(CHECKOUT, checkoutData);
      setLoading(null);
      navigate("/Checkout");
    } catch (error) {
      console.error("Checkout failed:", error);
      toast({
        type: ERROR,
        message: "Failed to load cart. Please try again.",
      });
      setLoading(null);
    }
  };

const handleBuyNow = async () => {
  if (!product?.id) return;

  const isSteelProduct =
    product?.category?.[0]?.categoryName?.toLowerCase() === "steel";
  const hasAppliedVariants = isSteelProduct && appliedData.length > 0;

  // Handle Steel Variants - Direct Buy Now (NO CART)
  if (hasAppliedVariants) {
    // ... (existing steel variant logic - unchanged) ...
    return;
  }

  setLoadingAction({ id: product.id, type: "buynow" });

  try {
    if (isEmptyObj(customer)) {
      navigate("/login");
      return;
    }

    // DETERMINE PRICING STRATEGY
    const addToCartQty = quantity;
    const itemsPrice = parseFloat(product.price || 0) * addToCartQty; // MRP total

    let actualUnitPrice = parseFloat(product.price || 0);
    let discountMode = "none"; 
    let discountValue = 0;
    let totalDiscountValue = 0;

    // TIERED PRICING (Cement with qtyAndPrice)
    if (product.qtyAndPrice?.length > 0 && selectedTier) {
      const customerType = customer?.customerType || "individual";
      
      // Use tiered price (discount already baked in)
      actualUnitPrice = customerType === "dealer" || customerType === "sub-dealer"
        ? parseFloat(selectedTier.setB2bPrice || 0)
        : parseFloat(selectedTier.setB2cPrice || 0);
      
      discountMode = "none";  
      discountValue = 0;     
      
      // Calculate discount as difference between MRP and tiered price
      const tieredTotal = actualUnitPrice * addToCartQty;
      totalDiscountValue = itemsPrice - tieredTotal; 
    } 
    //REGULAR PRICING (NO tiered pricing)
    else {
      const isB2B = customer && 
        (customer.customerType === "dealer" || customer.customerType === "sub-dealer");
      
      // Use B2B/B2C discount fields ONLY when NO tiered pricing
      discountMode = isB2B 
        ? (product.b2bDiscountMode?.toLowerCase() || "none") 
        : (product.b2cDiscountMode?.toLowerCase() || "none");
      
      discountValue = isB2B 
        ? (parseFloat(product.b2bDiscountValue) || 0) 
        : (parseFloat(product.b2cDiscountValue) || 0);
      
      // Calculate discount amount
      if (discountMode === "percent") {
        const unitDiscount = (discountValue / 100) * actualUnitPrice;
        totalDiscountValue = unitDiscount * addToCartQty;
      } else if (discountMode === "amount") {
        totalDiscountValue = discountValue * addToCartQty;
      }
    }

    const itemDeliveryCharge = parseFloat(product.deliveryCharge || 0) * addToCartQty;
    const totalPrice = itemsPrice - totalDiscountValue + itemDeliveryCharge; 

    const checkoutData = {
      totalItems: 1,
      billAmount: itemsPrice,         
      totalDiscount: totalDiscountValue,
      totalDeliveryCharge: itemDeliveryCharge,
      totalAmount: totalPrice,       
      isBuyNow: true,
      orderItems: [
        {
          id: product.id,
          productId: product.id,
          qty: addToCartQty,
          price: actualUnitPrice,    
          name: product.name,
          mainImage: product.mainImage,
          discountMode: discountMode,  
          discountValue: discountValue, 
          deliveryCharge: product.deliveryCharge || 0,
          total: actualUnitPrice * addToCartQty, 
          b2bDiscountMode: product.b2bDiscountMode || "none",
          b2bDiscountValue: product.b2bDiscountValue || 0,
          b2cDiscountMode: product.b2cDiscountMode || "none",
          b2cDiscountValue: product.b2cDiscountValue || 0,
        },
      ],
    };

    await setToLocalStorage(CHECKOUT, checkoutData);
    setLoadingAction({ id: null, type: null });
    navigate("/Checkout");
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to process Buy Now";
    toast({ type: ERROR, message });
    setLoadingAction({ id: null, type: null });
  }
};

  const totalRatings = useMemo(
    () => Object.values(ratingCounts).reduce((a, b) => a + b, 0),
    [ratingCounts],
  );
  const totalReviews =
    product.ratingAndReview?.filter((rr) => rr.review)?.length || 0;

  // Frquently Bought Random Api
  useEffect(() => {
    const frequentlyBought = async () => {
      try {
        const response = await api.get(
          `/product/?productStatus=active&shopStatus=active&type=popular`,
        );

        let products = [];
        if (response.data.data && response.data.data.length >= 2) {
          const filtered = response.data.data.filter((p) => p.id !== productID);

          products = filtered.slice(0, 2).map((p) => ({
            ...p,
            quantity: 1,
          }));
        }
        setFrequentlyBoughtProducts(products);
      } catch (error) {
        console.error("Error fetching frequently bought products:", error);
      }
    };
    if (productID) {
      frequentlyBought();
    }
  }, [productID]);

const handleAddToCart = async (e, from, targetProduct = null) => {
  e.preventDefault();
  if (!product?.id) return;
  const itemToAdd = targetProduct || product;
  if (!itemToAdd?.id) return;

  const isSteelProduct =
    product?.category?.[0]?.categoryName?.toLowerCase() === "steel";
  const hasAppliedVariants = isSteelProduct && appliedData.length > 0;

  if (hasAppliedVariants) {
    setLoadingAction({
      id: itemToAdd.id,
      type: from === "buynow" ? "buynow" : "add",
    });
    try {
      if (isEmptyObj(customer)) {
        navigate("/login");
        return;
      }
      await handleSteelVariantsAddToCart(itemToAdd, from, appliedData);
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to add to cart";
      toast({ type: ERROR, message });
    } finally {
      setLoadingAction({ id: null, type: null });
    }
    return;
  }

//DETERMINE PRICING STRATEGY USING B2B/B2C FIELDS
const addToCartQty = targetProduct ? 50 : quantity;

// Original MRP Price (always base price × quantity)
const itemsPrice = parseFloat(itemToAdd.price || 0) * addToCartQty;

// Determine actual price per unit and discount using B2B/B2C fields
let actualUnitPrice = parseFloat(itemToAdd.price || 0);
let discountMode = "none";
let discountValue = 0;
let totalDiscountValue = 0;

//Use B2B/B2C discount fields based on customer type
const isB2B = customer && 
  (customer.customerType === "dealer" || customer.customerType === "sub-dealer");

if (isB2B) {
  discountMode = itemToAdd.b2bDiscountMode?.toLowerCase() || "none";
  discountValue = parseFloat(itemToAdd.b2bDiscountValue) || 0;
} else {
  discountMode = itemToAdd.b2cDiscountMode?.toLowerCase() || "none";
  discountValue = parseFloat(itemToAdd.b2cDiscountValue) || 0;
}

// Check for tiered pricing (cement products)
if (itemToAdd.qtyAndPrice?.length > 0 && selectedTier) {
  const customerType = customer?.customerType || "individual";
  
  // Use tiered price (discount already baked in)
  actualUnitPrice = customerType === "dealer" || customerType === "sub-dealer"
    ? parseFloat(selectedTier.setB2bPrice || 0)
    : parseFloat(selectedTier.setB2cPrice || 0);
  
  // Tiered pricing has discount baked in → NO additional discount
  discountMode = "none";
  discountValue = 0;
  
  // Calculate discount as difference between MRP and tiered price
  const tieredTotal = actualUnitPrice * addToCartQty;
  totalDiscountValue = itemsPrice - tieredTotal;
} else {
  // Regular pricing with discount (using B2B/B2C fields)
  if (discountMode === "percent") {
    const unitDiscount = (discountValue / 100) * actualUnitPrice;
    totalDiscountValue = unitDiscount * addToCartQty;
  } else if (discountMode === "amount") {
    totalDiscountValue = discountValue * addToCartQty;
  }
}

//totalPrice = actual price × qty + delivery (NOT minus discount again!)
const itemDeliveryCharge = parseFloat(itemToAdd.deliveryCharge || 0) * addToCartQty;
const totalPrice = (actualUnitPrice * addToCartQty) + itemDeliveryCharge;

  setLoadingAction({
    id: itemToAdd.id,
    type: from === "buynow" ? "buynow" : "add",
  });

  try {
    if (isEmptyObj(customer)) {
      navigate("/login");
      return;
    }

    // EXISTING CART WITH NEW ITEM
    if (cartData.length > 0 && !isInCart()) {
      const cartItemsPrice = parseFloat(cartData[0].itemsPrice || 0) + itemsPrice;
      const cartTotalDiscount = parseFloat(cartData[0].totalDiscountValue || 0) + totalDiscountValue;
      const cartDeliveryCharge = parseFloat(cartData[0].totalDeliveryCharge || 0) + itemDeliveryCharge;
      const cartTotalPrice = cartItemsPrice - cartTotalDiscount + cartDeliveryCharge;

      const data = {
        customerId: cartData[0].customerId,
        itemsPrice: cartItemsPrice,          
        totalDiscountValue: cartTotalDiscount,
        discountMode: discountMode,
        totalDeliveryCharge: cartDeliveryCharge,
        totalPrice: cartTotalPrice,          
        cartItems: [
          ...cartData[0].cartItems,
          {
            productId: itemToAdd.id,
            qty: addToCartQty,
            price: actualUnitPrice,         
            discountMode: discountMode,      
            discountValue: discountValue,    
            deliveryCharge: itemToAdd.deliveryCharge || 0,
          },
        ],
      };

      const response = await api.put(
        `/cart/?id=${cartData[0].id}`,
        data,
        customerReqConfig()
      );
      if (response.status === 200) {
        toast({ type: SUCCESS, message: response.data.message });
        await fetchcart();
        await fetchCartCount();
        if (from === "buynow") await handleCheckout();
      }
    } 
    //EXISTING CART WITH EXISTING ITEM (increment qty) 
    else if (cartData.length > 0 && isInCart()) {
      const cartItemIndex = cartData[0].cartItems.findIndex(
        (c) => String(c.productId) === String(itemToAdd.id)
      );
      
      if (cartItemIndex === -1) throw new Error("Product not found in cart");
      
      const updatedCartItems = [...cartData[0].cartItems];
      
      // Handle tiered pricing when incrementing
      if (itemToAdd.qtyAndPrice?.length > 0 && selectedTier) {
        const currentQty = updatedCartItems[cartItemIndex].qty;
        const newTotalQty = currentQty + addToCartQty;
        
        // Find correct tier for new total quantity
        const applicableTier = itemToAdd.qtyAndPrice.find(t => 
          newTotalQty >= t.minQty && newTotalQty <= t.maxQty
        ) || itemToAdd.qtyAndPrice[itemToAdd.qtyAndPrice.length - 1];
        
        const customerType = customer?.customerType || "individual";
        const newUnitPrice = customerType === "dealer" || customerType === "sub-dealer"
          ? parseFloat(applicableTier.setB2bPrice || 0)
          : parseFloat(applicableTier.setB2cPrice || 0);
        
        updatedCartItems[cartItemIndex].qty = newTotalQty;
        updatedCartItems[cartItemIndex].price = newUnitPrice;
        updatedCartItems[cartItemIndex].discountMode = "none";
        updatedCartItems[cartItemIndex].discountValue = 0;
      } else {
        // Regular products - just increment qty
        updatedCartItems[cartItemIndex].qty += addToCartQty;
      }

      // Recalculate totals from scratch 
      let cartItemsPrice = 0;
      let cartTotalDiscount = 0;
      let cartDeliveryCharge = parseFloat(cartData[0].totalDeliveryCharge || 0);

      updatedCartItems.forEach((item) => {
        cartItemsPrice += parseFloat(item.price || 0) * parseInt(item.qty || 1);
        
        let itemDiscount = 0;
        if (item.discountMode === "percent") {
          itemDiscount = (parseFloat(item.discountValue) / 100) * parseFloat(item.price);
        } else if (item.discountMode === "amount") {
          itemDiscount = parseFloat(item.discountValue);
        }
        cartTotalDiscount += itemDiscount * parseInt(item.qty || 1);
        cartDeliveryCharge += parseFloat(item.deliveryCharge || 0) * parseInt(item.qty || 1);
      });

      const cartTotalPrice = cartItemsPrice - cartTotalDiscount + cartDeliveryCharge;

      const data = {
        customerId: cartData[0].customerId,
        itemsPrice: cartItemsPrice,
        totalDiscountValue: cartTotalDiscount,
        discountMode: cartData[0].discountMode,
        totalDeliveryCharge: cartDeliveryCharge,
        totalPrice: cartTotalPrice,
        cartItems: updatedCartItems,
      };

      const response = await api.put(
        `/cart/?id=${cartData[0].id}`,
        data,
        customerReqConfig()
      );
      if (response.status === 200) {
        toast({ type: SUCCESS, message: response.data.message });
        await fetchcart();
        await fetchCartCount();
        if (from === "buynow") await handleCheckout();
      }
    } 
    //NEW CART
    else {
      const data = {
        customerId: customer?.id || "0",
        itemsPrice: itemsPrice,              
        totalDiscountValue: totalDiscountValue,
        discountMode: discountMode,          
        totalDeliveryCharge: itemDeliveryCharge,
        totalPrice: totalPrice,             
        cartItems: [
          {
            productId: itemToAdd.id,
            qty: addToCartQty,
            price: actualUnitPrice,         
            discountMode: discountMode,      
            discountValue: discountValue,    
            deliveryCharge: itemToAdd.deliveryCharge || 0,
          },
        ],
      };

      const response = await api.post("/cart/", data, customerReqConfig());
      if (response.status === 200) {
        toast({ type: SUCCESS, message: response.data.message });
        await fetchcart();
        await fetchCartCount();
        if (from === "buynow") await handleCheckout();
      }
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to add to cart";
    toast({ type: ERROR, message });
  } finally {
    setLoadingAction({ id: null, type: null });
  }
};

  useEffect(() => {
    switch (selectedStars) {
      case 1:
        setMessage("Very Poor");
        break;
      case 2:
        setMessage("Poor");
        break;
      case 3:
        setMessage("Average");
        break;
      case 4:
        setMessage("Good");
        break;
      case 5:
        setMessage("Excellent");
        break;
      default:
        break;
    }
  }, [selectedStars]);

  const b2bDiscountUnitPrice =
    product?.b2bDiscountMode?.toLowerCase() === "percent"
      ? parseFloat(product.price) -
        parseFloat(product.b2bDiscountValue / 100) * parseFloat(product.price)
      : parseFloat(product.price) - parseFloat(product.b2bDiscountValue);
  const b2cDiscountUnitPrice =
    product?.b2cDiscountMode?.toLowerCase() === "percent"
      ? parseFloat(product.price) -
        parseFloat(product.b2cDiscountValue / 100) * parseFloat(product.price)
      : parseFloat(product.price) - parseFloat(product.b2cDiscountValue);

  const b2bSubTotal = Math.round(b2bDiscountUnitPrice).toFixed(2);
  const b2cSubTotal = Math.round(b2cDiscountUnitPrice).toFixed(2);

  //Discount value
  const isB2B =
    customer &&
    (customer.customerType === "dealer" ||
      customer.customerType === "sub-dealer");
  const activeDiscountMode = isB2B
    ? product.b2bDiscountMode
    : product.b2cDiscountMode;
  const activeDiscountValue = isB2B
    ? product.b2bDiscountValue
    : product.b2cDiscountValue;

  const b2bitemQuantity = (parseFloat(b2bSubTotal) * quantity).toFixed(2);
  const b2citemQuantity = (parseFloat(b2cSubTotal) * quantity).toFixed(2);
  const overallAvg = ratingAvg1(product.ratingAndReview);

  // tiered pricing structure for Cement
  const customerType = customer?.customerType || "individual";
  // const matchedTier = product?.qtyAndPrice?.find(t => quantity >= t.minQty && quantity <= t.maxQty) || product?.qtyAndPrice?.[0];
  const unitPrice = selectedTier
    ? customerType === "dealer" || customerType === "sub-dealer"
      ? selectedTier.setB2bPrice
      : selectedTier.setB2cPrice
    : 0;
  const totalPrice = unitPrice * quantity;
  const mrpPrice = product.price * quantity;
  const qpDiscountValue = useMemo(() => {
    return mrpPrice - totalPrice;
  }, [mrpPrice, totalPrice]);

  //rating images
  const allMedia = useMemo(() => {
    return (
      product?.ratingAndReview
        ?.flatMap((review) => review.image)
        .filter(Boolean) || []
    );
  }, [product]);

  //product highlights
  const decodeHtml = (str) => {
    if (!str) return "";

    // Create a textarea to decode HTML entities
    const txt = document.createElement("textarea");

    let current = str;
    let decoded = "";

    // Keep decoding until no more changes (handles double/triple encoding)
    do {
      decoded = current;
      txt.innerHTML = decoded;
      current = txt.value;
    } while (current !== decoded);

    return current;
  };
  const groupedSpecs = useMemo(() => {
    const groups = {};
    product?.productSpecification?.forEach((spec) => {
      const cleanedGroup = decodeHtml(spec.groupName);

      if (!groups[cleanedGroup]) {
        groups[cleanedGroup] = [];
      }

      groups[cleanedGroup].push({
        title: spec.title,
        description: spec.description || "-",
      });
    });
    return Object.entries(groups).map(([groupName, items]) => ({
      groupName,
      items,
    }));
  }, [product]);

  // console.log("priceBrek", priceBreakup);

  const handleApply = () => {
    if (!product?.productVariant?.length) return;

    const kg40Map = {
      "06 mm": 2.9,
      "08 mm": 4.815,
      "10 mm": 7.525,
      "12 mm": 10.825,
      "16 mm": 19.263,
      "18 mm": 24.35,
      "20 mm": 30.109,
      "25 mm": 46.932,
      "32 mm": 76.919,
    };

    // Store BOTH display data AND cart-ready data
    const breakup = [];
    const cartVariants = [];

    selectedSizes.forEach((size) => {
      const qty = selectedSizesQuantities[size] || 1;
      const variant = product.productVariant.find((v) => v.title === size);
      if (!variant) return;

      // Calculate price based on customer type
      const unitPrice =
        customer?.customerType === "dealer" ||
        customer?.customerType === "sub-dealer"
          ? variant.b2bDiscountMode.toLowerCase() === "percent"
            ? variant.price - (variant.price * variant.b2bDiscountValue) / 100
            : variant.price - variant.b2bDiscountValue
          : variant.b2cDiscountMode.toLowerCase() === "percent"
            ? variant.price - (variant.price * variant.b2cDiscountValue) / 100
            : variant.price - variant.b2cDiscountValue;

      let totalWeight = 0;
      let label = "";

      if (quantityType === "kg") {
        totalWeight = qty;
        label = `${qty} KG (${size})`;
      } else {
        const weightPerPiece = kg40Map[size] || 0;
        const roundedWeight = Math.round(weightPerPiece);
        totalWeight = qty * roundedWeight;
        label = `${totalWeight} KG (${size})`;
      }

      const amount = totalWeight * unitPrice;
      const price = variant.price;

      // Store display data
      breakup.push({
        label,
        price,
        amount: amount.toFixed(2),
        totalWeight: totalWeight.toFixed(2),
        variantTitle: size,
      });

      // steel cart data
      cartVariants.push({
        variantId: variant.id,
        variantTitle: size,
        qty: totalWeight,
        unit: quantityType,
        price: price,
        // netAmount:price,
        discountMode:
          customer?.customerType === "dealer" ||
          customer?.customerType === "sub-dealer"
            ? variant.b2bDiscountMode
            : variant.b2cDiscountMode,
        discountValue:
          customer?.customerType === "dealer" ||
          customer?.customerType === "sub-dealer"
            ? variant.b2bDiscountValue
            : variant.b2cDiscountValue,
      });
    });

    const totalKg = breakup
      .reduce((sum, item) => sum + parseFloat(item.totalWeight), 0)
      .toFixed(2);
    const netAmount = breakup
      .reduce((sum, item) => {
        return sum + parseFloat(item.price) * parseFloat(item.totalWeight);
      }, 0)
      .toFixed(2);
    const totalAmount = breakup
      .reduce((sum, item) => sum + parseFloat(item.amount), 0)
      .toFixed(2);
    const discount = (netAmount - totalAmount).toFixed(2);

    // Set BOTH states
    setPriceBreakup({
      rows: breakup,
      totalKg,
      netAmount,
      discount,
      totalAmount,
    });

    setAppliedData(cartVariants);
  };

  

  const handleSteelVariantsAddToCart = async (itemToAdd, from, variants) => {
    try {
      if (cartData.length > 0) {
        const existingCartItems = [...cartData[0].cartItems];

        variants.forEach((variantItem) => {
          const existingIndex = existingCartItems.findIndex(
            (item) =>
              String(item.productId) === String(itemToAdd.id) &&
              String(item.variant) === String(variantItem.variantId),
          );

          if (existingIndex !== -1) {
            // Update quantity if variant already exists
            existingCartItems[existingIndex].qty += variantItem.qty;
          } else {
            // Add new variant item
            existingCartItems.push({
              productId: itemToAdd.id,
              variant: variantItem.variantId,
              qty: variantItem.qty,
              unit: variantItem.unit,
              price: variantItem.price,
              discountMode: variantItem.discountMode,
              discountValue: variantItem.discountValue,
              deliveryCharge: itemToAdd.deliveryCharge || 0,
            });
          }
        });

        // Calculate totals
        let itemsPrice = 0;
        let totalDiscountValue = 0;
        let totalDeliveryCharge = parseFloat(
          cartData[0].totalDeliveryCharge || 0,
        );

        existingCartItems.forEach((item) => {
          itemsPrice += parseFloat(item.price || 0) * item.qty;

          let discount = 0;
          if (item.discountMode?.toLowerCase() === "percent") {
            discount =
              (parseFloat(item.discountValue) / 100) * parseFloat(item.price);
          } else if (item.discountMode?.toLowerCase() === "amount") {
            discount = parseFloat(item.discountValue);
          }
          totalDiscountValue += discount * item.qty;
        });

        const totalPrice =
          itemsPrice - totalDiscountValue;

        const data = {
          customerId: cartData[0].customerId,
          itemsPrice,
          totalDiscountValue,
          totalDeliveryCharge,
          totalPrice,
          cartItems: existingCartItems,
        };

        const response = await api.put(
          `/cart/?id=${cartData[0].id}`,
          data,
          customerReqConfig(),
        );

        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: `${variants.length} variants added to cart`,
          });
          setAppliedData([]); // Clear after adding
          await fetchcart();
          await fetchCartCount();
          if (from === "buynow") await handleCheckout();
        }
      } else {
        // Create new cart with variants
        const cartItems = variants.map((item) => ({
          productId: itemToAdd.id,
          variant: item.variantId,
          qty: item.qty,
          unit: item.unit,
          price: item.price,
          discountValue: item.discountValue,
          discountMode: item.discountMode, 
          deliveryCharge: itemToAdd.deliveryCharge || 0,
        }));

        // Calculate totals
        let itemsPrice = 0;
        let totalDiscountValue = 0;
        let totalDeliveryCharge = 0;

        cartItems.forEach((item) => {
          itemsPrice += parseFloat(item.price || 0) * item.qty;

          let discount = 0;
          if (item.discountMode?.toLowerCase() === "percent") {
            discount =
              (parseFloat(item.discountValue) / 100) * parseFloat(item.price);
          } else if (item.discountMode?.toLowerCase() === "amount") {
            discount = parseFloat(item.discountValue);
          }
          totalDiscountValue += discount * item.qty;
          totalDeliveryCharge += parseFloat(item.deliveryCharge || 0);
        });

        const totalPrice =
          itemsPrice - totalDiscountValue + totalDeliveryCharge;

        const data = {
          customerId: customer?.id || "0",
          itemsPrice,
          totalDiscountValue,
          totalDeliveryCharge,
          totalPrice,
          cartItems,
        };

        const response = await api.post("/cart/", data, customerReqConfig());

        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: `${variants.length} variants added to cart`,
          });
          setAppliedData([]); // Clear after adding
          await fetchcart();
          await fetchCartCount();
          if (from === "buynow") await handleCheckout();
        }
      }
    } catch (error) {
      throw error;
    }
  };

  const [addedToCartMap, setAddedToCartMap] = useState({});
  const [bestSellers, setBestSellers] = useState([]);
  const [bestSellerCategoryId, setBestSellerCategoryId] = useState(null);
  const [hotDealsCategoryId, setHotDealsCategoryId] = useState(null);
  const [hotDeals, setHotDeals] = useState([]);
  const [reloadKey, setReloadKey] = useState(0);
  const [dealsOfTheDayCategoryId, setDealsOfTheDayCategoryId] = useState(null);
  const [dayDeals, setDayDeals] = useState([]);

  useEffect(() => {
    const handleCartUpdate = () => {
      loadCartData(customer.id, setCartData, setAddedToCartMap);
    };

    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);
  const getHomeCategory = () => {
    setFetchLoading(true);
    api
      .get("/category/?flag=getHomeAndChilds")
      .then((response) => {
        if (response.status === 200) {
          const Allitems = response.data.data[0].childs;
          const deals1 = Allitems.find(
            (item) => item.name === "Deals Of The Day",
          );
          const deals2 = Allitems.find((item) => item.name === "Hot Deals");
          const deals3 = Allitems.find((item) => item.name === "Best Sellers");
          const deals4 =
            Allitems.find((item) => item.name === "New Arrivals")?.products ||
            [];

          if (deals1) setDealsOfTheDayCategoryId(deals1.id);
          if (deals2) setHotDealsCategoryId(deals2.id);
          if (deals3) setBestSellerCategoryId(deals3.id);

          setDayDeals(deals1?.products || []);
          setHotDeals(deals2?.products || []);
          setBestSellers(deals3?.products || []);
        }
      })
      .catch(() => {})
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getHomeCategory();
  }, []);
  return (
    <section className="product-details py-40">
      <div className="container-fluid mb-24">
        <div className="row">
          <div className="col-xl-3"></div>

          {/* Breadcrumb */}
          <div className="col-xl-6 ">
            <nav className="d-flex flex-wrap items-center justify-content-center align-item-center gap-8 text-sm text-gray-500">
              <Link to="/" className="navigation-bar-prc-det transition-colors">
                Home
              </Link>
              <span className="text-gray-400 select-none">{">"}</span>
              <Link
                to="/category-products"
                className="navigation-bar-prc-det transition-colors"
              >
                All Categories
              </Link>
              <span className="text-gray-400 select-none">{">"}</span>
              {product?.category?.[0]?.categoryName && (
                <>
                  <Link
                    to={`/category-products/${product.category[0].categoryId}`}
                    className="navigation-bar-prc-det transition-colors"
                  >
                    {product.category[0].categoryName}
                  </Link>
                  <span className="text-gray-400 select-none">{">"}</span>
                </>
              )}
              <span className="navigation-bar-prc-det  text-gray-400">
                {product.name}
              </span>
            </nav>
          </div>
          {/* Compare & Share Icons */}
          <div className="col-xl-3 ">
            <div className="d-flex align-items-center gap-10">
              <label className="d-flex align-items-center  cursor-pointer">
                <input
                  type="checkbox"
                  className="custom-checkbox me-2 "
                  checked={compareList.some((p) => p.id === product.id)}
                  onChange={handleCompareList}
                  // style={{ accentColor: "#ff6600",color:'white' }}
                />
                <span className="navigation-bar-prc-det">Compare</span>
              </label>

              {/* Share Icon */}
              <button
                className=" btn-btn text-gray-400 m border-none"
                title="Share"
                onClick={(e) => {
                  e.preventDefault();
                  if (navigator.share) {
                    navigator.share({
                      title: product.name,
                      text: `Check out: ${product.name}`,
                      url: window.location.href,
                    });
                  } else {
                    // Fallback: Copy link to clipboard
                    navigator.clipboard.writeText(window.location.href);
                    alert("Link copied to clipboard!");
                  }
                }}
              >
                <i class="fas fa-share"></i>
                <span className="navigation-bar-prc-det">share</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-3">
            <div className="product-details__left">
              <div className="product-details__thumb-slider border border-gray-100 rounded-16 position-relative py-40 px-32">
                <div
                  className="position-absolute top-0 end-0 m-12 d-flex align-items-center"
                  title={
                    wishlistProductIds.includes(String(product.id))
                      ? "Already in Wishlist"
                      : "Add to Wishlist"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    wishListHandler(product);
                  }}
                  style={{ cursor: "pointer" }}
                  disabled={loading === product.id}
                >
                  {loading === product.id ? (
                    <div
                      className="spinner-border spinner-border-sm text-secondary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : wishlistProductIds.includes(String(product.id)) ? (
                    <Feather.Heart
                      fill="red"
                      color="red"
                      size={22}
                      strokeWidth={1.6}
                    />
                  ) : (
                    <Feather.Heart size={22} strokeWidth={1.6} />
                  )}
                </div>

                <div className="">
                  <div className="product-details__thumb flex-center h-100">
                    {mainImage && (
                      <img alt="Main Product" src={baseURL + "/" + mainImage} />
                    )}
                  </div>
                </div>
              </div>
              {productImages.length > 0 && (
                <div className="mt-24 d-flex justify-content-center">
                  <div className="product-details__images-slider">
                    <Slider {...settingsThumbs}>
                      {[...Array(3)].map((_, i) => {
                        const imageIndex = i % productImages.length;
                        const image = productImages[imageIndex];
                        return (
                          <div
                            key={i}
                            className=" border border-gray-100 rounded-16 hover-border-main-600 transition-1 center h-100 flex-center p-16"
                            onClick={() => setMainImage(image)}
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img
                              src={baseURL + "/" + image}
                              alt={`Thumbnail ${i}`}
                              style={{
                                width: "30px",
                                height: "34px",
                                objectFit: "cover",
                                display: "block",
                                minWidth: "30px",
                                maxWidth: "30px",
                                boxSizing: "border-box",
                              }}
                              onError={(e) => {
                                console.warn(
                                  "Image failed to load:",
                                  e.target.src,
                                );
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-6">
            <div className="product-details__content border border-gray-100 rounded-16">
              <div className=" mt-14 px-32">
                <h5>{product.name}</h5>

                <div className="flex-align flex-wrap gap-12">
                  <div className="flex-align gap-12 flex-wrap">
                    <span className="fw-medium text-neutral-600">
                      <div className="badge bg-success">
                        {ratingAvg1(product.ratingAndReview)}{" "}
                        <i className="ph-fill ph-star" />
                      </div>
                    </span>
                    <span className="fw-medium text-gray-500">
                      ({product?.ratingAndReview?.length})
                    </span>
                  </div>
                  <span className="fw-medium text-gray-500">|</span>
                  <span className="text-gray-900">
                    {" "}
                    <span className="text-gray-400">PTC :</span>
                    {product.code}
                  </span>
                </div>
                <hr />
                <div>
                  <div className="flex-align gap-8 flex-wrap mb-4">
                    {product?.qtyAndPrice?.length > 0 ? (
                      <h6 className="text-3xl mb-0 font-semibold text-black">
                        ₹{totalPrice?.toFixed(2)}
                      </h6>
                    ) : (
                      <h6 className="text-3xl mb-0 font-semibold text-black">
                        ₹
                        {!customer ||
                        customer.customerType === "dealer" ||
                        customer.customerType === "sub-dealer"
                          ? b2bSubTotal
                          : b2cSubTotal}
                      </h6>
                    )}

                    {product?.qtyAndPrice?.length > 0 ? (
                      <span className="text-sm text-main-two-600 fw-bold">
                        Discount of ₹{qpDiscountValue.toFixed(2)}
                      </span>
                    ) : (
                      activeDiscountValue > 0 &&
                      activeDiscountMode && (
                        <span className="text-sm text-main-two-600 fw-bold">
                          Discount of{" "}
                          {activeDiscountMode === "Percent"
                            ? `${activeDiscountValue}% `
                            : `₹${activeDiscountValue} `}
                        </span>
                      )
                    )}
                  </div>
                  <div className="flex-align gap-2 mt-2">
                    <span className="text-gray-700">M.R.P:</span>
                    <h5
                      className="text-2xl text-gray-400 mb-0 line-through"
                      style={{ textDecoration: "line-through" }}
                    >
                      {product?.qtyAndPrice?.length > 0
                        ? `₹${mrpPrice.toFixed(2)}`
                        : `₹${product?.price?.toFixed(2)}`}
                    </h5>
                  </div>

                  <p className="text-gray-500 fs-5 mt-2">
                    Inclusive of all taxes
                  </p>

                  <div className="mt-24">
                    <ul className="list-unstyled mb-0">
                      <li className="flex-align gap-8 py-2 mb-3">
                        <span className="text-xs text-main-600 prod-desc-check-icon ">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-gray-900 text-sm">
                          <strong>Product Name:</strong>{" "}
                          <span className="text-gray-600"> {product.name}</span>
                        </span>
                      </li>

                      {product.code && (
                        <li className="flex-align gap-8 py-2 mb-3">
                          <span className="text-xs text-main-600 prod-desc-check-icon">
                            <i className="ph ph-check"></i>
                          </span>
                          <span className="text-gray-900 text-sm">
                            <strong>Item Code:</strong>
                            <span className="text-gray-600">
                              {product.code || "N/A"}
                            </span>
                          </span>
                        </li>
                      )}

                      {product.warrantyPeriod !== null &&
                        product.warrantyPeriod !== undefined &&
                        product.warrantyPeriod > "0" && (
                          <li className="flex-align gap-8 py-2 mb-3">
                            <span className="text-xs text-main-600 prod-desc-check-icon">
                              <i className="ph ph-check"></i>
                            </span>
                            <span className="text-gray-900 text-sm">
                              <strong>Warranty Period:</strong>
                              <span className="text-gray-600">
                                {product.warrantyPeriod > 0
                                  ? `${product.warrantyPeriod} ${product.warrantyMode}`
                                  : "N/A"}
                              </span>
                            </span>
                          </li>
                        )}

                      {product.warrantyLabel && (
                        <li className="flex-align gap-8 py-2 mb-3">
                          <span className="text-xs text-main-600 prod-desc-check-icon">
                            <i className="ph ph-check"></i>
                          </span>
                          <span className="text-gray-900 text-sm">
                            <strong>Warranty Label:</strong>
                            <span className="text-gray-600">
                              {product.warrantyLabel || "N/A"}
                            </span>
                          </span>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div style={{ textAlign: "end", marginTop: "40px" }}>
                    <span className="text-gray-900 text-sm fw-medium">
                      100% Guarantee Safe Checkout
                    </span>
                  </div>
                  <hr />
                </div>
              </div>
              {/* qty and price for cement  */}
              <div className="">
                {product?.qtyAndPrice?.length > 0 && (
                  <div className="py-40 px-32">
                    <div className="row">
                      <div className="col-4 d-flex justify-content-center align-items-center">
                        <span className="fw-bold text-dark">
                          select quantity (in   {qtyTiers?.[0]?.basedOn})*:
                        </span>
                      </div>
                      <div className="col-5">
                        <QuantityControlQty
                          quantity={quantity}
                          setQuantity={handleQuantityChange}
                          incrementQuantity={handleIncrement}
                          decrementQuantity={handleDecrement}
                          buttonsDisabled={""}
                          isLoadingInc={""}
                          isLoadingDec={""}
                        />
                      </div>
                    </div>
                    <div className="mt-40">
                      <div className="row">
                        {qtyTiers.map((qp) => (
                          <div key={qp.id} className="col-3">
                            <div
                              onClick={() => handleTierClick(qp)}
                              style={{
                                border:
                                  activeIndex === qp.id
                                    ? "2px solid #DB6510"
                                    : "2px solid #D5DCE0",
                                borderRadius: "8px",
                                padding: "5px",
                                cursor: "pointer",
                                transition: "border-color 0.2s ease",
                              }}
                            >
                              <span
                                className="text-dark fw-bold d-block"
                                style={{ padding: "8px 26px" }}
                              >
                                Min {qp.minQty}
                                <br />
                              {qp.basedOn
                                  ? qp.basedOn.charAt(0).toUpperCase() + qp.basedOn.slice(1)
                                  : ""}
                              </span>

                              <hr className="m-0 border-2" />

                              <span
                                className="text-dark fw-bold d-block"
                                style={{ padding: "8px 20px" }}
                              >
                                ₹
                                {!customer ||
                                customer.customerType === "dealer" ||
                                customer.customerType === "sub-dealer"
                                  ? qp.setB2bPrice
                                  : qp.setB2cPrice}{" "}
                                / {qp.basedOn
                                  ? qp.basedOn.charAt(0).toUpperCase() + qp.basedOn.slice(1)
                                  : ""}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mt-24">
                      <span className="text-dark fw-bold">*Note:</span>
                      <span className="text-dark">
                        Net weight of 1bag contains 50 kg
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {/* For Steel / Variants */}
              {product?.category?.[0]?.categoryName?.toLowerCase() ===
                "steel" && (
                <div className="mb-24">
                  <ProductSizeSelector
                    variants={product?.productVariant || []}
                    selectedSizes={selectedSizes}
                    onToggleSize={handleToggleSize}
                    onQuantityChange={handleQuantityChangeSteel}
                    onApply={handleApply}
                    quantityType={quantityType}
                    setQuantityType={setQuantityType}
                    selectedSizesQuantities={selectedSizesQuantities}
                    customer={customer}
                  />
                </div>
              )}
            </div>
          </div>
          {/* right side price calculation column */}
          <div className="col-xl-3">
            <div className="product-details__sidebar border border-gray-100 rounded-16">
              <div className=" py-30 px-14 ">
                <h6 htmlFor="delivery" className="mb-12 text-xl fw-bold">
                  Delivery
                </h6>
                <div className="flex-align border border-gray-100 rounded-4 px-16">
                  <span className="text-xl d-flex text-main-600">
                    <i className="ph ph-map-pin" />
                  </span>
                  <select
                    className="common-input border-0 px-8 rounded-4"
                    id="delivery"
                    disabled={addressList.length === 0}
                  >
                    {addressList.length > 0 ? (
                      addressList.map((address, index) => (
                        <option key={index} value={address.id}>
                          {address.locality || `Address ${index + 1}`}
                        </option>
                      ))
                    ) : (
                      <option>No address found</option>
                    )}
                  </select>
                </div>
              </div>
              {product?.qtyAndPrice?.length <= 0 &&
                product?.productVariant?.length <= 0 && (
                  <div className=" py-30 px-14 ">
                    <label className="activePage mb-8 text-heading fw-semibold d-block">
                      Quantity
                    </label>
                    <QuantityControl
                      quantity={quantity}
                      setQuantity={setQuantity}
                      incrementQuantity={handleIncrement}
                      decrementQuantity={handleDecrement}
                      buttonsDisabled={""}
                      isLoadingInc={""}
                      isLoadingDec={""}
                    />
                  </div>
                )}
              {/* other category price caluculation */}
              {product?.productVariant?.length <= 0 && (
                <div className="py-30 px-14 ">
                  <div className="flex-between flex-wrap gap-8 border-bottom  pb-16 mb-16">
                    <span className="text-gray-500">Price</span>
                    <h6 className="text-lg mb-0">
                      ₹
                      {product?.qtyAndPrice?.length > 0
                        ? totalPrice?.toFixed(2)
                        : !customer ||
                            customer.customerType === "dealer" ||
                            customer.customerType === "sub-dealer"
                          ? b2bitemQuantity
                          : b2citemQuantity}
                    </h6>
                  </div>
                  {product?.qtyAndPrice?.length > 0 && (
                    <div className="flex-between flex-wrap gap-8 border-bottom  pb-16 mb-16">
                      <span className="text-gray-500">Net weight(kg)</span>
                      <h6 className="text-lg mb-0">{quantity * product?.weight}</h6>
                    </div>
                  )}

                  {/* <div className="flex-between flex-wrap gap-8">
                  <span className="text-gray-500">Shipping</span>
                  {product.deliveryCharge > 0 && (
                    <h6 className="text-lg mb-0">
                      ₹ {(product.deliveryCharge ?? 0).toFixed(2)}
                    </h6>
                  )}
                </div> */}
                </div>
              )}

              {/* Price Breakup Chart */}
              {product?.productVariant?.length > 0 && (
                <div className="mb-24">
                  <div className="px-14">
                    <h6 className="fs-6">Price breakup chart</h6>
                  </div>
                  <div>
                    <div
                      className="d-flex justify-content-between py-10 px-20"
                      style={{ backgroundColor: "#F2F2F2" }}
                    >
                      <p className="text-dark" style={{ fontWeight: "600" }}>
                        Weight(Size)
                      </p>
                      <p className="text-dark" style={{ fontWeight: "600" }}>
                        Price
                      </p>
                    </div>
                    {priceBreakup.rows.map((row, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between py-8 px-20"
                      >
                        <p
                          className="text-dark"
                          style={{ fontWeight: "600", fontSize: "small" }}
                        >
                          {row.label}
                        </p>
                        <p
                          className="text-dark"
                          style={{ fontWeight: "600", fontSize: "small" }}
                        >
                          ₹{row.amount}
                        </p>
                      </div>
                    ))}
                    <div className="px-20 border-top pt-12 mt-12">
                      <div className="d-flex justify-content-between">
                        <h6 className="text-dark fs-6">Net weight(kg)</h6>
                        <h6 className="text-dark fs-6">
                          {priceBreakup.totalKg}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between">
                        <h6 className="text-dark fs-6">Net Amount</h6>
                        <h6 className="text-dark fs-6">
                          ₹{priceBreakup.netAmount}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between">
                        <h6 className="text-success fs-6">Discount</h6>
                        <h6 className="text-success fs-6">
                          (-) ₹{priceBreakup.discount}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between fw-bold">
                        <span className="text-dark fs-6">Total Amount</span>
                        <span className="text-dark fs-6">
                          ₹{priceBreakup.totalAmount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isInCart() ? (
                <Link
                  to="/cart"
                  className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-48 w-100 btn-primary"
                >
                  Go to cart
                </Link>
              ) : (
                <>
                  {/* Add to Cart Button */}
                  <button
                    className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-48 w-100"
                    disabled={
                      loadingAction.id === product.id &&
                      loadingAction.type === "add"
                    }
                    onClick={(e) => handleAddToCart(e, "add")}
                  >
                    {loadingAction.id === product.id &&
                    loadingAction.type === "add" ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>{" "}
                        Adding...
                      </>
                    ) : (
                      "Add to cart"
                    )}
                  </button>

                  {/* Buy Now Button */}
                  <button
                    className="btn btn-outline-main rounded-8 py-16 fw-normal mt-16 w-100"
                    disabled={
                      loadingAction.id === product.id &&
                      loadingAction.type === "buynow"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      handleBuyNow();
                    }}
                  >
                    {loadingAction.id === product.id &&
                    loadingAction.type === "buynow" ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>{" "}
                        Processing...
                      </>
                    ) : (
                      "Buy Now"
                    )}
                  </button>
                </>
              )}
              <div className="mt-32">
                <div className="px-16 py-8 bg-main-50 rounded-8 flex-between gap-24 mb-14">
                  <span className="w-32 h-32 bg-white text-main-600 rounded-circle flex-center text-xl flex-shrink-0">
                    <i className="ph-fill ph-truck" />
                  </span>
                  <span className="text-sm text-neutral-600">
                    Ship from <span className="fw-semibold">PTC</span>{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* product highlight */}
        <div className="container-fluid mb-24 mt-24">
          <div className="row gap-">
            <div className="col-xl-3"></div>
            <div className="col-xl-6 ">
              <div className="product-details__content border border-gray-100 rounded-16 py-40 px-32">
                <h6 className="text-xl fw-bold mb-24">Product Description</h6>
                <hr className="full-width-hr" />
                <p dangerouslySetInnerHTML={{ __html: product.description }} />
              </div>
            </div>
            <div className="col-xl-3 "></div>
          </div>
        </div>
        {/* product specification */}
        <div className="container-fluid mb-24">
          <div className="row gap-">
            <div className="col-xl-3"></div>
            <div className="col-xl-6 mb-4">
              {groupedSpecs.length > 0 && (
                <div className="mt-3">
                  {groupedSpecs.map((section, i) => (
                    <div key={i} className="mb-24">
                      <div
                        className="bg-white border rounded-16"
                        style={{ border: "2px solid #D5DCE0" }}
                      >
                        {/* Group Name Header */}
                        <div className="px-24 py-18  border-bottom border-2 fw-bold text-dark">
                          {section.groupName}
                        </div>

                        {/* Specs rows */}
                        {section.items.map((item, idx) => (
                          <div
                            key={idx}
                            className={`row g-0  align-items-center border-bottom 
                            ${idx === section.items.length - 1 ? "border-bottom-0" : ""}`}
                          >
                            {/* Title */}
                            <div className="col-6 border-end px-30 py-20">
                              <span className="text-dark fw-medium">
                                {item.title}
                              </span>
                            </div>

                            {/* Description */}
                            <div className="col-6 px-30 py-20">
                              <span className="text-dark">
                                {item.description}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="col-xl-3 "></div>
          </div>
        </div>
        {/* Rating section */}
        <div className="container-fluid mb-24">
          <div className="row">
            <div className="col-xl-3"></div>
            <div className="col-xl-6">
              <div className="product-details__content border border-gray-100 rounded-16 py-40 px-32">
                <h6 className="text-xl fw-bold mb-24">Ratings & Reviews</h6>
                <hr className="full-width-hr" />
                {product?.ratingAndReview?.length === 0 ? (
                  <div className="px-3 py-2 text-center text-muted fs-6">
                    No ratings or reviews yet.
                  </div>
                ) : (
                  <>
                    {/* Overall Rating & Stats */}
                    <div className="d-flex flex-wrap gap-44 mb-20 justify-content-center align-items-center">
                      {/* Left side */}
                      <div className="px-40 py-52 flex-center flex-column flex-shrink-0 text-center ">
                        <h6 className="text-xl fw-bold mb-24">
                          {(() => {
                            const avg = ratingAvg1(product.ratingAndReview);
                            if (avg >= 4.5) return "Excellent";
                            if (avg >= 4.0) return "Great";
                            if (avg >= 3.0) return "Good";
                            if (avg >= 2.0) return "Fair";
                            return "Poor";
                          })()}
                        </h6>

                        <div className="flex-align gap-2 mb-12">
                          {[...Array(5)].map((_, i) => {
                            const average = ratingAvg1(product.ratingAndReview);
                            const isFull = i < Math.floor(average);
                            const isHalf = !isFull && i < average;

                            return (
                              <span key={i} className="text-xl d-flex">
                                {isFull ? (
                                  <i className="ph-fill ph-star rating-review-start-color" />
                                ) : isHalf ? (
                                  <i className="ph-fill ph-star-half rating-review-start-color" />
                                ) : (
                                  <i className="ph ph-star text-gray-300" />
                                )}
                              </span>
                            );
                          })}
                        </div>

                        <p className="text-center text-muted m-0">
                          {totalRatings}{" "}
                          {totalRatings === 1 ? "Rating" : "Ratings"} &{" "}
                          {totalReviews}{" "}
                          {totalReviews === 1 ? "Review" : "Reviews"}
                        </p>
                      </div>

                      {/* Right side */}
                      <div className="px-24 py-0 flex-grow-1 rating-review-right">
                        {[5, 4, 3, 2, 1].map((star) => {
                          const count = ratingCounts[star] || 0;
                          const percent = totalRatings
                            ? (count / totalRatings) * 100
                            : 0;

                          return (
                            <div key={star} className="flex-align gap-5 mb-10 ">
                              <span
                                className="text-gray-900 flex-shrink-0 d-inline-block text-end"
                                style={{ width: "30px" }}
                              >
                                {star} &#9733;
                              </span>
                              <div
                                className="progress rating-progress-bar bg-gray-100 rounded-pill h-10"
                                role="progressbar"
                                aria-valuenow={percent}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              >
                                <div
                                  className="progress-bar-fill rounded-pill"
                                  style={{ width: `${percent}%` }}
                                />
                              </div>
                              <div className="flex-align gap-4">
                                {/* {[...Array(5)].map((_, i) => (
                                    <span
                                      key={i}
                                      className={`text-xs fw-medium d-flex ${
                                        i < star
                                          ? "rating-review-start-color"
                                          : "text-gray-400"
                                      }`}
                                    >
                                      <i className="ph-fill ph-star" />
                                    </span>
                                  ))} */}
                              </div>
                              <span className="text-gray-400 flex-shrink-0">
                                {count}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-around gap-10 mt-5"
                      style={{ marginBottom: "30px" }}
                    >
                      {[
                        { label: "Price" },
                        { label: "Quality" },
                        { label: "Delivery" },
                        { label: "Support" },
                      ].map((item, index) => {
                        const avg = overallAvg || 0;
                        const percent = (avg / 5) * 100;
                        const dashArray = (percent / 100) * 88; // 88 is full circumference

                        return (
                          <div
                            key={index}
                            className="d-flex flex-column align-items-center text-center mx-3"
                            // style={{ width: "80px" }}
                          >
                            {/* Circle */}
                            <div
                              className="position-relative"
                              style={{ width: "100px", height: "100px" }}
                            >
                              <svg className="w-80 h-100" viewBox="0 0 36 36">
                                {/* Outer Circle (background) */}
                                <circle
                                  cx="18"
                                  cy="18"
                                  r="14"
                                  fill="none"
                                  stroke="#e5e7eb"
                                  strokeWidth="2.5"
                                />
                                {/* Progress Circle */}
                                <circle
                                  cx="18"
                                  cy="18"
                                  r="14"
                                  fill="none"
                                  stroke="#F97316"
                                  strokeWidth="2.5"
                                  strokeDasharray={`${dashArray} 88`}
                                  strokeLinecap="round"
                                  transform="rotate(-90 18 18)"
                                />
                              </svg>
                              {/* Center Text */}
                              <div
                                className="position-absolute top-50 start-50 translate-middle"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#F97316",
                                }}
                              >
                                <span className="text-sm font-bold text-orange-600">
                                  {avg}
                                </span>
                              </div>
                            </div>

                            {/* Label */}
                            <span
                              className="text-sm fw-bold text-dark"
                              style={{ fontSize: "14px" }}
                            >
                              {item.label}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    <hr className="full-width-hr" />
                    <div>
                      <div style={{ marginBottom: "80px" }}>
                        <ModalGallery media={allMedia} />
                      </div>
                    </div>
                    <div>
                      <ReviewList product={product} />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="col-xl-3"></div>
          </div>
        </div>
        {/* product highlights */}
 {product?.highlight &&
  product.highlight.replace(/<[^>]*>/g, "").trim() !== "" && (
    <div className="container-fluid mb-24">
      <div className="row">
        <div className="col-xl-12">
          <div className="product-details__content border border-gray-100 rounded-16 py-40 px-32">
            <h6 className="text-xl fw-bold mb-24">Product Highlights</h6>
            <hr className="full-width-hr" />
            <div
              dangerouslySetInnerHTML={{
                __html: product.highlight,
              }}
            />
          </div>
        </div>
      </div>
    </div>
)}


       
      </div>
      {/* Frequently Bought Together */}
      {frequentlyBoughtProducts.length > 0 && (
        <div className="container container-lg mb-24 border border-gray-200 rounded-16 bg-white">
          <div className="row">
            <div className="col-xl-12">
              <div className="product-details__content py-32 px-24">
                <h6 className="text-xl fw-bold mb-24">
                  Frequently Bought Together
                </h6>

                {/* Product List */}
                <div className="d-flex flex-wrap gap-5 mb-24">
                  {frequentlyBoughtProducts.map((product, index) => {
                    const priceInfo = calculateProductPrice(product);
                    
                    return (
                         <React.Fragment key={product.id}>
                      <div
                        className="d-flex border rounded-12 shadow-sm p-4 bg-white align-items-center position-relative"
                        style={{ width: "400px", height: "300px" }}
                      >
                        {/* Product Image (Fixed Left) */}
                        <div
                          className="ms-7 me-16 bg-gray-100 d-flex justify-content-center align-items-center rounded-8"
                          style={{ width: "250px", height: "90%" }}
                        >
                          <img
                            src={baseURL + "/" + product.mainImage}
                            alt={product.name}
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                        </div>

                        {/* Product Info (Fixed Right) */}
                        <div
                          className="flex-grow- d-flex flex-column"
                          style={{ width: "240px", height: "90%" }}
                        >
                          <div className="d-flex justify-content-around align-items-start">
                            <h5
                              className="fw-semibold text-md mb-1 mt-40 text-truncate"
                              style={{ maxWidth: "150px", textWrap: "wrap" }}
                            >
                              {product.name}
                            </h5>
                            <label className="custom-checkbox-Add">
                              <input
                                type="checkbox"
                                checked={selectedAddOns.includes(product.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedAddOns((prev) => [
                                      ...prev,
                                      product.id,
                                    ]);
                                  } else {
                                    setSelectedAddOns((prev) =>
                                      prev.filter((id) => id !== product.id),
                                    );
                                  }
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>

                          {/* Store Info */}
                          <div className="flex-align gap-4 mt-12">
                            <span
                              className="text-orange-500 text-md d-flex"
                              style={{ color: "#fb5f00" }}
                            >
                              <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                              By PTC
                            </span>
                          </div>

                          <div className="list-product-price my-20">
                            {priceInfo.priceType === "productVariant" ? (
                              <>
                                <div className="text-gray-400 text-md fw-semibold text-decoration-line-through mb-2">
                                  {priceInfo.retailPriceDisplay}
                                </div>
                                <div className="text-heading text-md fw-semibold">
                                  {priceInfo.sellingPriceDisplay}
                                </div>
                              </>
                            ) : (
                              <>
                                {priceInfo.originalPrice && (
                                  <div className="text-gray-400 text-md fw-semibold text-decoration-line-through mb-2">
                                    ₹ {priceInfo.originalPrice}
                                  </div>
                                )}
                                <span className="text-heading text-md fw-semibold">
                                  ₹ {priceInfo.displayPrice}
                                  {priceInfo.qtyRange && (
                                    <span className="text-gray-500 fw-normal ms-2">
                                      ({priceInfo.qtyRange})
                                    </span>
                                  )}
                                  <span className="text-gray-500 fw-normal">
                                    {priceInfo.priceType === "qtyAndPrice"
                                      ? ""
                                      : "/Qty"}
                                  </span>
                                </span>
                              </>
                            )}
                          </div>

                          {/* Add to Cart */}
                          <button
                            className="btn btn-outline-main btn-sm mt-auto"
                            onClick={(e) => handleAddToCart(e, "add", product)}
                          >
                            Add To Cart
                          </button>
                        </div>
                      </div>

                      {/* + Symbol between products */}
                      {index !== frequentlyBoughtProducts.length - 1 && (
                        <div className="text-5xl  text-gray-400 align-self-center ms-5 me-5">
                          +
                        </div>
                      )}
                    </React.Fragment>
                    )
                 
})}
                </div>

                {/* Add All Items Button */}
                <div className="d-flex ">
                  <button
                    className="btn btn-main fw-bold px-15 py-12"
                    onClick={() => {
                      frequentlyBoughtProducts.forEach((item) =>
                        handleAddToCart(null, "add", item),
                      );
                    }}
                  >
                    ADD {selectedAddOns.length} ITEMS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ComparePopup
        compareList={compareList}
        removeFromCompare={removeFromCompare}
        clearCompareList={clearCompareList}
      />

      <SimilarProducts
        key={`FeaturedOne-${reloadKey}`}
        hotDeals={hotDeals}
        hotDealsCategoryId={hotDealsCategoryId}
        addedToCartMap={addedToCartMap}
        setCartData={setCartData}
        setAddedToCartMap={setAddedToCartMap}
      />

      <RecentlyView
        key={`TopSellingOne-${reloadKey}`}
        bestSellers={bestSellers}
        bestSellerCategoryId={bestSellerCategoryId}
        addedToCartMap={addedToCartMap}
        setCartData={setCartData}
        setAddedToCartMap={setAddedToCartMap}
      />

      <ExploreMore
        key={`DealsOne-${reloadKey}`}
        dayDeals={dayDeals}
        dealsOfTheDayCategoryId={dealsOfTheDayCategoryId}
        addedToCartMap={addedToCartMap}
        setCartData={setCartData}
        setAddedToCartMap={setAddedToCartMap}
      />
    </section>
  );
};

export default ProductDetails;

const ComparePopup = ({ compareList, removeFromCompare, clearCompareList }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  if (compareList.length === 0) return null;
  return (
    <div
      className="compare-popup-wrapper rounded-16"
      onMouseEnter={() => setShowPopup(true)}
      onMouseLeave={() => setShowPopup(false)}
      style={{ position: "relative", display: "inline-block" }}
    >
      {showPopup && (
        <div
          className={`d-flex justify-content-around pe-16 ${
            compareList.length === 1 ? "single" : ""
          }`}
        >
          {compareList.map((product) => (
            <div
              key={product.id}
              className={`compare-item ${
                compareList.length === 1 ? "single" : ""
              }`}
            >
              <div className="compare-img-wrapper">
                <img
                  src={baseURL + "/" + product.mainImage}
                  alt={product.name}
                  className="compare-img"
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFromCompare(product.id);
                  }}
                  className="remove-btn"
                  title="Remove"
                >
                  ✕
                </button>
              </div>
              <h6
                className="text-md fw-semibold"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                }}
              >
                {" "}
                {product?.name ? product.name.toUpperCase() : ""}
              </h6>
            </div>
          ))}
        </div>
      )}

      {/* Action Buttons */}
      <div>
        {compareList.length > 1 ? (
          <>
            <div className="d-flex align-items-center justify-content-around">
              {showPopup && (
                <button
                  onClick={clearCompareList}
                  className="btn btn-outline-main d-flex align-items-center me-3"
                >
                  REMOVE ALL
                </button>
              )}

              <button
                className="btn btn-main d-flex align-items-center gap-3"
                onClick={() => navigate("/compare-page")}
              >
                <span>COMPARE</span>
                <span className="compare-count">{compareList.length}</span>
              </button>
            </div>
          </>
        ) : (
          <button
            className="btn btn-main d-flex align-items-center gap-2"
            onClick={() => navigate("/compare-page")}
          >
            <span>COMPARE</span>
            <span className="compare-count">{compareList.length}</span>
          </button>
        )}
      </div>
    </div>
  );
};

//Modal for open gallery
const ModalGallery = ({ media }) => {
  const [show, setShow] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleOpenDetails = (item) => {
    setSelectedItem(item);
    setShowDetail(true);
  };
  const handleCloseDetails = () => {
    setSelectedItem(null);
    setShowDetail(false);
  };

  const getMediaType = (item) => {
    const videoExts = ["mp4", "webm", "ogg"];
    const ext = item?.split(".").pop().toLowerCase();
    return videoExts.includes(ext) ? "video" : "image";
  };

  const normalizedMedia = media.map((item) => ({
    url: item.attachmentUrl,
    type: getMediaType(item.attachmentUrl),
  }));

  const previewMedia = normalizedMedia.slice(0, 5);
  const remaining = normalizedMedia.length - 5;

  return (
    <div>
      <h6 className="text-xl fw-bold mb-2">Videos & Photos</h6>
      <span className="text-gray-500 mb-10">Uploaded by customer</span>

      <div className="d-flex mt-3 gap-14">
        {previewMedia.map((item, index) => (
          <div
            key={index}
            className="position-relative"
            style={{
              width: "100px",
              height: "100px",
              overflow: "hidden",
              borderRadius: "8px",
              flexShrink: 0,
              cursor: "pointer",
            }}
            onClick={() => handleOpenDetails(item)}
          >
            {item.type === "video" ? (
              <>
                <video
                  width="140"
                  height="140"
                  className="w-100 h-100"
                  style={{ objectFit: "cover" }}
                  muted
                >
                  <source src={baseURL + "/" + item.url} type="video/mp4" />
                </video>

                {/* Play button in center */}
                <div
                  className="position-absolute top-50 start-50 translate-middle bg-dark bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <i className="ph ph-play text-white fs-5"></i>
                </div>

                {/* Duration bottom-left */}
                <div
                  className="position-absolute bottom-0 start-0 px-2 py-1 bg-dark bg-opacity-75 text-white small rounded-top"
                  style={{ fontSize: "12px" }}
                >
                  {item.duration || "0:30"}
                </div>
              </>
            ) : (
              <img
                src={baseURL + "/" + item.url}
                alt="media"
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            )}

            {/* If it's the last preview item and more exist */}
            {index === 4 && remaining > 0 && (
              <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpen();
                }}
              >
                <span className="fw-bold text-white fs-5">+{remaining}</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <span className="text-xl text-gray-900 fw-bold">
            User Images ({normalizedMedia.length})
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap gap-5">
            {normalizedMedia.map((item, index) => (
              <div
                key={index}
                className="overflow-hidden "
                style={{
                  width: "140px",
                  height: "140px",
                  marginBottom: "20px",
                }}
                onClick={() => handleOpenDetails(item)}
              >
                {item.type === "video" ? (
                  <video className="w-100 h-100 object-fit-cover" controls>
                    <source src={baseURL + "/" + item.url} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={baseURL + "/" + item.url}
                    alt="media"
                    className="w-100 h-100 object-fit-cover"
                  />
                )}
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>

      {/* second modal for open selected image */}
      <Modal show={showDetail} onHide={handleCloseDetails} size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="d-flex p-0" style={{ height: "600px" }}>
          {/* Left side: Media */}
          <div className="flex-grow-1 bg-black d-flex align-items-center justify-content-center">
            {selectedItem &&
              (selectedItem.type === "video" ? (
                <video
                  src={baseURL + "/" + selectedItem.url}
                  controls
                  className="w-100 h-100 object-fit-contain"
                />
              ) : (
                <img
                  src={baseURL + "/" + selectedItem.url}
                  alt="preview"
                  className="w-100 h-100 object-fit-contain"
                />
              ))}
          </div>

          {/* Right side: Empty white space */}
          {/* <div
              style={{ width: "40%", background: "#fff" }}
              className="d-flex align-items-center justify-content-center"
            >
              <span className="text-muted">Right side content (empty now)</span>
            </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

//Product Review
const ReviewList = ({ product }) => {
  const [showAll, setShowAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 2;

  // Track likes/dislikes state per reviewId
  const [reviewReactions, setReviewReactions] = useState({});

  if (!product?.ratingAndReview) return null;

  const totalReviews = product.ratingAndReview.length;

  // Calculate paginated reviews
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = showAll
    ? product.ratingAndReview.slice(indexOfFirstReview, indexOfLastReview)
    : product.ratingAndReview.slice(0, 2);

  const totalPages = Math.ceil(totalReviews / reviewsPerPage);

  // Handle reaction logic
  const handleReaction = (reviewId, type) => {
    setReviewReactions((prev) => {
      const prevReaction = prev[reviewId]?.reaction;
      let likeCount = prev[reviewId]?.likes || 0;
      let disLikeCount = prev[reviewId]?.disLikes || 0;

      if (type === "like") {
        if (prevReaction === "like") {
          // already liked → undo like
          likeCount -= 1;
          return {
            ...prev,
            [reviewId]: {
              reaction: null,
              likes: likeCount,
              disLikes: disLikeCount,
            },
          };
        } else {
          // switching from dislike → remove dislike and add like
          if (prevReaction === "dislike") disLikeCount -= 1;
          likeCount += 1;
          return {
            ...prev,
            [reviewId]: {
              reaction: "like",
              likes: likeCount,
              disLikes: disLikeCount,
            },
          };
        }
      }

      if (type === "dislike") {
        if (prevReaction === "dislike") {
          // already disliked → undo dislike
          disLikeCount -= 1;
          return {
            ...prev,
            [reviewId]: {
              reaction: null,
              likes: likeCount,
              disLikes: disLikeCount,
            },
          };
        } else {
          // switching from like → remove like and add dislike
          if (prevReaction === "like") likeCount -= 1;
          disLikeCount += 1;
          return {
            ...prev,
            [reviewId]: {
              reaction: "dislike",
              likes: likeCount,
              disLikes: disLikeCount,
            },
          };
        }
      }

      return prev;
    });
  };

  return (
    <div>
      {currentReviews.map((review, index) => {
        const reviewId = review.customerId + "-" + index; // unique id for reaction tracking
        const reactions = reviewReactions[reviewId] || {
          likes: 0,
          disLikes: 0,
          reaction: null,
        };

        return (
          <div
            key={index}
            className="d-flex align-items-start gap-24 pb-3 mb-24 border-bottom"
          >
            <div className="flex-grow-1">
              <div className="d-flex justify-content-between align-items-start gap-2">
                <div className="d-flex align-items-center gap-2">
                  <div className="badge bg-success">{review.rating} ★</div>
                  <span className="fw-semibold text-gray-900 fs-6">
                    {review.name || `User-${review.customerId || "Guest"}`}
                  </span>
                </div>
                <span className="text-gray-600 text-xs">
                  {review.createTimestamp &&
                  !isNaN(new Date(review.createTimestamp).getTime())
                    ? new Date(review.createTimestamp).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        },
                      )
                    : "Date not available"}
                </span>
              </div>

              <p className="mb-20 mt-16 text-md text-gray-900">
                {review.review}
              </p>

              {/* Like/Dislike Buttons */}
              <div className="d-flex justify-content-end gap-26">
                <button onClick={() => handleReaction(reviewId, "like")}>
                  <i
                    className="ph ph-thumbs-up"
                    style={{ color: "gray", fontWeight: "bold" }}
                  ></i>
                  <span
                    style={{
                      fontSize: "15px",
                      marginLeft: "4px",
                      color: "gray",
                    }}
                  >
                    {reactions.likes}
                  </span>
                </button>
                <button onClick={() => handleReaction(reviewId, "dislike")}>
                  <i
                    className="ph ph-thumbs-down"
                    style={{ color: "gray", fontWeight: "bold" }}
                  ></i>
                  <span
                    style={{
                      fontSize: "15px",
                      marginLeft: "4px",
                      color: "gray",
                    }}
                  >
                    {reactions.disLikes}
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      })}

      {!showAll && totalReviews > 2 && (
        <div
          className="text-primary fw-semibold cursor-pointer mt-2"
          onClick={() => setShowAll(true)}
        >
          All {totalReviews} Reviews &gt;
        </div>
      )}

      {showAll && totalPages > 1 && (
        <nav className="d-flex justify-content-center mt-3">
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </button>
            </li>

            {[...Array(totalPages)].map((_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              </li>
            ))}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

//steel
const ProductSizeSelector = ({
  variants,
  selectedSizes,
  onToggleSize,
  onQuantityChange,
  selectedSizesQuantities,
  customer,
  onApply,
  quantityType,
  setQuantityType,
}) => {
  const [showSizeChart, setShowSizeChart] = useState(false);

  return (
    <div>
      <div className="py-40 px-32">
        {/* Select quantity dropdown */}
        <div className="row mb-3 mt-24">
          <div className="col-6 d-flex">
            <span className="fw-bold text-dark text-nowrap me-2">
              Select quantity :
            </span>
            <select
              className="form-select form-select-sm"
              value={quantityType}
              onChange={(e) => setQuantityType(e.target.value)}
              style={{
                fontSize: "14px",
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #d5dce0",
                backgroundColor: "#fff",
              }}
            >
              <option value="kg">Kilograms</option>
              <option value="number">Number</option>
            </select>
          </div>
        </div>

        {/* Select Size Row */}
        <div className="row mb-14 mt-24">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <span className="fw-bold text-dark">Select Size:</span>
            <button
              className="text-orange-500 fw-semibold text-sm"
              style={{ color: "#DB6510" }}
              onClick={() => setShowSizeChart(true)}
            >
              View Size Chart
            </button>
          </div>
        </div>

        {/* Size Cards — 4 per row */}
        <div className="row g-3 mb-4">
          {variants.map((v, i) => {
            const isSelected = selectedSizes.includes(v.title);
            const pricePerKg =
              !customer ||
              customer.customerType === "dealer" ||
              customer.customerType === "sub-dealer"
                ? v.b2bDiscountMode.toLowerCase() === "percent"
                  ? v.price - (v.price * v.b2bDiscountValue) / 100
                  : v.price - v.b2bDiscountValue
                : v.b2cDiscountMode.toLowerCase() === "percent"
                  ? v.price - (v.price * v.b2cDiscountValue) / 100
                  : v.price - v.b2cDiscountValue;

            // Original price (strikethrough)
            const originalPrice = v.price.toFixed(2);
            // Discounted price (bold)
            const discountedPrice = pricePerKg.toFixed(2);

            return (
              <div key={i} className="col-3">
                <div
                  onClick={() => onToggleSize(v.title)}
                  style={{
                    border: isSelected
                      ? "2px solid #DB6510"
                      : "1.5px solid #E0E0E0",
                    borderRadius: "10px",
                    padding: "14px 10px",
                    cursor: "pointer",
                    background: "#fff",
                    position: "relative",
                    height: "120px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Check circle */}
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      border: isSelected ? "none" : "1.5px solid #D5DCE0",
                      backgroundColor: isSelected ? "#DB6510" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    {isSelected && "✓"}
                  </div>

                  {/* Size */}
                  <div className="text-center">
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: "16px",
                        color: "#111",
                      }}
                    >
                      {v.title}
                    </span>
                  </div>
                  <hr className="m-0" />
                  <div className="">
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#9CA3AF",
                        fontWeight: "bold",
                        textDecoration: "line-through",
                      }}
                    >
                      ₹{originalPrice}/Kg
                    </span>
                  </div>

                  {/* New price */}
                  <div className="">
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: "15px",
                        color: "#111",
                      }}
                    >
                      ₹{discountedPrice}/Kg
                    </span>
                  </div>
                </div>
                <SizeChartModal
                  isOpen={showSizeChart}
                  onClose={() => setShowSizeChart(false)}
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* Quantity Table */}
      {selectedSizes.length > 0 && (
        <div className="mt-14">
          {/* Header */}
          <div
            className="d-flex justify-content-between py-10 px-40"
            style={{
              background: "#F3F4F6",
              borderBottom: "1px solid #E5E7EB",
              fontWeight: 600,
              alignItems: "center",
            }}
          >
            <span className="text-dark fw-bold ">Diameter</span>
            <span className="text-dark fw-bold">Quantity</span>
          </div>

          {/* Rows */}
          {selectedSizes.map((size, idx) => (
            <div
              key={idx}
              className="d-flex justify-content-between align-items-center p-10 px-44"
            >
              {/* Diameter */}
              <span style={{ fontWeight: 600, color: "black" }}>{size}</span>

              {/* Quantity Control */}
              <div
                className="d-flex align-items-center"
                style={{
                  border: "1px solid #D1D5DB",
                  borderRadius: "6px",
                  overflow: "hidden",
                  height: "36px",
                }}
              >
                {/* Minus Button */}
                <button
                  onClick={() =>
                    onQuantityChange(
                      size,
                      Math.max(1, (selectedSizesQuantities[size] || 1) - 1),
                    )
                  }
                  disabled={(selectedSizesQuantities[size] || 1) <= 1}
                  style={{
                    width: "36px",
                    height: "100%",
                    fontSize: "18px",
                    fontWeight: "bold",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid #D9D9D9",
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  −
                </button>

                {/* Input */}
                <input
                  type="number"
                  min="1"
                  value={selectedSizesQuantities[size] || 1}
                  onChange={(e) =>
                    onQuantityChange(size, parseInt(e.target.value) || 1)
                  }
                  style={{
                    width: "60px",
                    height: "100%",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "500",
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                  onFocus={(e) => e.target.select()}
                />

                {/* Plus Button */}
                <button
                  onClick={() =>
                    onQuantityChange(
                      size,
                      (selectedSizesQuantities[size] || 1) + 1,
                    )
                  }
                  style={{
                    width: "36px",
                    height: "100%",
                    fontSize: "18px",
                    fontWeight: "bold",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderLeft: "1px solid #D9D9D9",
                    userSelect: "none",
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  +
                </button>
              </div>
            </div>
          ))}

          {/* Apply Button */}
          <div className="text-center mt-28">
            <button
              onClick={onApply}
              style={{
                backgroundColor: "#FA6403",
                color: "#fff",
                border: "none",
                padding: "12px 68px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// sizeChartModal

const SizeChartModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "600px",
          margin: "auto",
        }}
      >
        <div className="modal-content" style={{ border: "1px solid black" }}>
          <div className="modal-header border-bottom-0 pb-0 justify-content-center position-relative">
            <h5 className="modal-title fw-bold fs-5 text-center w-100">
              Steel Size Chart
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              style={{ border: "none", boxShadow: "none", outline: "none" }}
            />
          </div>
          <div className="modal-body pt-0">
            <table className="table table-sm table-borderless mb-3">
              <thead>
                <tr style={{ backgroundColor: "#f3f4f69f" }}>
                  <th className="fw-semibold text-dark">Diameter</th>
                  <th className="fw-semibold text-dark text-center">
                    Kg per metre as per ISI (1m = 3.281 ft)
                  </th>
                  <th className="fw-semibold text-dark text-center">
                    Kg per 40 feet (Approx)
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { d: "06mm", kgM: "0.222", kg40: "2.900" },
                  { d: "08mm", kgM: "0.395", kg40: "4.815" },
                  { d: "10mm", kgM: "0.617", kg40: "7.525" },
                  { d: "12mm", kgM: "0.888", kg40: "10.825" },
                  { d: "16mm", kgM: "1.580", kg40: "19.263" },
                  { d: "18mm", kgM: "2.340", kg40: "24.350" },
                  { d: "20mm", kgM: "2.470", kg40: "30.109" },
                  { d: "25mm", kgM: "3.850", kg40: "46.932" },
                  { d: "32mm", kgM: "6.310", kg40: "76.919" },
                ].map((row, i) => (
                  <tr key={i}>
                    <td className="text-dark">{row.d}</td>
                    <td className="text-dark text-center">{row.kgM}</td>
                    <td className="text-dark text-center">{Math.round(Number(row.kg40))}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="alert alert-info p-3 mb-0">
              <small className="text-muted">
                <strong>Disclaimer:</strong> The weights and sizes provided in
                this TMT size chart are approximate and meant for reference
                only. Actual weights may vary slightly due to manufacturing
                tolerances and rolling differences.
              </small>
            </div>
          </div>
          <div className="modal-footer border-top-0 pt-0">
            <button
              className="btn btn-primary w-100"
              onClick={onClose}
              style={{
                backgroundColor: "#007bff",
                borderColor: "#007bff",
                fontWeight: 600,
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
